/** @jsxImportSource solid-js */
import { createContext, useContext, type JSX } from "solid-js";
import { type WidgetStore } from "../store/widget-store";

const WidgetContext = createContext<WidgetStore>();

export function WidgetProvider(props: { store: WidgetStore; children: JSX.Element }): JSX.Element {
  return <WidgetContext.Provider value={props.store}>{props.children}</WidgetContext.Provider>;
}

export function useWidgetStore(): WidgetStore {
  const store = useContext(WidgetContext);
  if (!store) throw new Error("WidgetProvider missing");
  return store;
}
